import { useEffect, useState } from 'react';
import DatePicker from 'react-datepicker';
import { parseDatetime } from '../../helpers/timezone';

import './date_time_picker.scss';

const DateTimePicker = ({
  label,
  name,
  value,
  valid,
  disabled = false,
  validationText = 'This field is required!',
  onChange,
  showYearDropdown,
  showTimeInput,
}) => {
  const [date, setDate] = useState(null);

  useEffect(() => {
    if (value?.toString() !== 'Invalid Date') {
      setDate(parseDatetime(value));
    }
  }, [value]);

  const errorClass = valid ? '' : 'error';

  return (
    <div className={`input-group ${errorClass}`}>
      <label className="flex items-center">{label}</label>

      <div className="only-date-picker">
        <DatePicker
          name={name}
          selected={date}
          showPopperArrow={false}
          showTimeInput={showTimeInput}
          showYearDropdown={showYearDropdown}
          dropdownMode="select"
          dateFormat={showTimeInput ? 'dd/MM/yyyy HH:mm' : 'dd/MM/yyyy'}
          timeFormat="HH:mm"
          disabled={disabled}
          onChange={onChange}
        />
      </div>
      {!valid && <span className="error">{validationText}</span>}
    </div>
  );
};

export default DateTimePicker;
